import React from 'react';
import { AppState } from './App'
import './ProvideOtp.css';
import { getApi } from './Api'
import { ProvideOtp400Response, ProvideOtp401Response, ProvideOtp403Response, ProvideOtpRequest } from './api/api';
import axios, { AxiosResponse } from 'axios';
import OtpInput from './OtpInput';
import toast from "react-hot-toast";

interface ComponentProps {
	changeState: (newState: AppState) => void
	phoneNumber: string
}

type State = {
	otp: string
	showError: boolean
	isOtpValid: boolean
	buttonDisabled: boolean
	phoneNumber: string
 }
export default class ProvideOtp extends React.Component<ComponentProps, State> {

	state: State

	constructor(props: ComponentProps) {
		console.log('ProvideOtp')
		super(props)
		this.state = {
			otp: "",
			showError: false,
			isOtpValid: false,
			buttonDisabled: true,
			phoneNumber: props.phoneNumber
		}
	}

	componentDidMount() { }

	provideOtp = (e: React.FormEvent) => {
		console.log('provideOtp')
		e.preventDefault();
		this.setState({ showError: true })
		const api = getApi()
		const req: ProvideOtpRequest = {
			otp: this.state.otp,
			phoneNumber: this.state.phoneNumber
		}
		api.provideOtp(req).then(
			(resp: AxiosResponse) => {
				console.log('authenticateUser success')
				this.props.changeState(AppState.STATE_DELETE_CONFIRMATION)
			}).catch((error: any) => {
				if (axios.isAxiosError(error)) {
					// Now you can access error.response
					if (error.response) {
						switch (error.response.status) {
							case 400:
								const errorData400 = error.response.data as ProvideOtp400Response;
								console.log('400 Error: ', errorData400);
								toast("Internal Error", {
									duration: 5000,
									position: "bottom-right",
									style: { backgroundColor: "#2E3237", color: "#FFFFFF" },
								});
								this.props.changeState(AppState.STATE_INITIAL)
								break;
							case 401:
								const errorData401 = error.response.data as ProvideOtp401Response;
								toast("Internal Error", {
									duration: 5000,
									position: "top-center",
									style: { backgroundColor: "#2E3237", color: "#FFFFFF" },
								});
								console.log('401 Error: ', errorData401);
								this.props.changeState(AppState.STATE_INITIAL)
								break;
							case 403:
								const errorData403 = error.response.data as ProvideOtp403Response;
								console.log('403 Error: ', errorData403);
								this.props.changeState(AppState.STATE_TOO_MANY_ATTEMPTS)
								break;
							case 404:
								const errorData404 = error.response.data as ProvideOtp401Response;
								console.log('404 Error: ', errorData404);
								toast("Wrong OTP provided", {
									duration: 5000,
									position: "top-center",
									style: { backgroundColor: "#2E3237", color: "#FFFFFF", fontSize: "30px" },
								});
								break;
							default:
								// Handle other errors
								console.log('Other Error: ', error.response.data);
						}
					} else {
						// The request was made but no response was received
						console.log('Error: No response received', error.message);
					}
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log('Error: ', error.message);
				}
			})
		// api.
	}

	validateOtp = (otp: string) => {
		const isOtpValid = otp !== '' && otp.length === 4 && /^\d+$/.test(otp);
		console.log(`isOtpValid ${isOtpValid}`)
		this.setState({ isOtpValid: isOtpValid, buttonDisabled: !isOtpValid });
		return isOtpValid
	};

	setOtp(otp: string) {
		console.log(`setOtp(${otp})`)
		this.setState({ otp })
		this.validateOtp(otp)
	}

	handleOutput(Otp: string) {
		console.log("Provided OTP -> ", Otp)
		this.setOtp(Otp)
	}

	formatPhoneNumber(phoneNumber: string): string {
		// Check for the initial '+' symbol and country code (assuming it's always +1)
		if (phoneNumber.startsWith('+1') && phoneNumber.length === 12) {
		  const countryCode = phoneNumber.slice(0, 2);
		  const areaCode = phoneNumber.slice(2, 5);
		  const firstPart = phoneNumber.slice(5, 8);
		  const secondPart = phoneNumber.slice(8, 12);
		  return `${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
		} else {
		  // If the phone number doesn't match the expected format, return it as is or handle accordingly
		  return phoneNumber;
		}
	  }

	render() {
		return (
			<div className="provide-otp-container">
				<div className="provide-otp-card">
					<form>
						<div className="logos">
							{/* Add your logos here */}
						</div>
						<h1>Verify Account</h1>
						<div className="message">
							{ `To make sure it's really you, a` }
							<strong>{ ` 4-digit verification` }</strong>
							{ ` code was sent to` }
							<br/><strong>{ ` ${this.formatPhoneNumber(this.state.phoneNumber)}` }</strong>
							{ ` via SMS. Please enter it below.` }
						</div>
						{this.state.showError && !this.state.isOtpValid && <div className="error-message">Invalid OTP</div>}
						<div className="otp-input-div-container" >
							<OtpInput
								amount={4}
								autoFocus
								handleOutputString={this.handleOutput.bind(this)}
								inputRegExp={/^[0-9]$/}
							/>
						</div>
						<div className="resend-otp">Didn't get it? Resend code</div>
						<button type="submit"
							disabled={this.state.buttonDisabled}
							onClick={this.provideOtp}>Continue</button>
					</form>
				</div>
			</div>
		);
	}
};
